import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceResourceGroupEditionNotificationState = createStateReducer(
  initialState,
  {
    [events.editResourceGroupSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editResourceGroup",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.editResourceGroupFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editResourceGroup",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceResourceGroupEditionNotificationState };
